





















































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import RewardPointProductApi from '@/api/marketing/rewardPointMall/product/index'

@Component({
  components: {
    CustomForm
  }
})
export default class ProductList extends AbpBase {
  filters = [
    {
      label: '关键词',
      type: 'input',
      props: {
        placeholder: '请输入商品名称或商品货号'
      },
      key: 'keyWord'
    },
    {
      label: '类型',
      type: 'select',
      props: {
        placeholder: '请选择商品类型'
      },
      options: [
        {
          value: '0',
          text: '实物商品'
        },
        {
          value: '1',
          text: '虚拟商品'
        }
      ],
      key: 'productType'
    }
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '商品名称',
      key: 'productName',
      width: 350,
      align: 'center'
    },
    {
      title: '货号',
      key: 'productCode',
      width: 220,
      align: 'center'
    },
    {
      title: '类型',
      key: 'productTypeDisplayName',
      align: 'center'
    },
    {
      title: '积分',
      key: 'rewardPoint',
      align: 'center'
    },
    {
      title: '金额',
      key: 'price',
      align: 'center'
    },
    {
      title: '库存',
      key: 'stockQuantity',
      align: 'center'
    },
    // {
    //   title: '分类',
    //   key: 'categoryName',
    //   align: 'center'
    // },
    {
      title: '下架/上架',
      slot: 'published',
      width: 100,
      align: 'center'
    },
    {
      title: '操作',
      slot: 'action',
      width: 170,
      align: 'center'
    }
  ]
  isCheckAll: boolean = false
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0
  tabList = ['全部', '已上架', '未上架']
  activeTab = 0

  submitChange(form, valid) {
    if (valid) {
      this.getTableData(form)
    }
  }

  mounted() {
    this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  getTableData(form = {}) {
    this.isCheckAll = false
    let keyWord = form['keyWord']
    let productType = form['productType']
    let { pageSize, currentPage, activeTab } = this
    let published = activeTab == 0 ? null : activeTab == 1 ? true : false
    RewardPointProductApi.getList(
      pageSize,
      currentPage,
      keyWord,
      productType,
      published
    )
      .then(res => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }


  getProductSalesAttributeValues(arr: any[]) {
    return arr.map(item => item.name).join('，')
  }

  /**
   * 更改上架状态
   */
  publishedChange(row) {
    let ids: any = [row.id]
    RewardPointProductApi.updatePublished(ids, row.published).then(res => {
      this.submitFn()
    })
  }

  deleteRow(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDelete(row.id)
      }
    })
  }

  handleDelete(id: string | number) {
    RewardPointProductApi.deleteById(id).then(res => {
      this.submitFn()
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  /**
   * 批量上/下架
   */
  publishedChangeAll(state: boolean) {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log('批量上/下架', state)
      let ids = selection.map(item => {
        return item.id
      })
      RewardPointProductApi.updatePublished(ids, state).then(res => {
        this.submitFn()
      })
    } else {
      this.$Notice.warning({
        title: '请先选择商品'
      })
    }
  }

  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log('执行删除')
      this.$Modal.confirm({
        title: '批量删除商品规格',
        content: `是否删除已选中的商品规格?`,
        onOk: () => {
          console.log('点了确定了')
        }
      })
    } else {
      this.$Notice.warning({
        title: '请先选择商品'
      })
    }
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }
}
